import { useEffect, useRef } from 'react';

const { naver } = window
const NaverLoginBtn = ({ metaInfo = {} }) => {

    const naverRef = useRef();
    const strState = new URLSearchParams(metaInfo).toString();

    useEffect(() => {
        const naverLogin = new naver.LoginWithNaverId({
            clientId: process.env.REACT_APP_NAVER_CLIENT_ID,
            callbackUrl: `${process.env.REACT_APP_NAVER_REDIRECT_URL}?${strState}`,
            isPopup: false, /* 팝업을 통한 연동처리 여부, true 면 팝업 */
            loginButton: { color: "green", type: 1, height: 47 }/* 로그인 버튼의 타입을 지정 */
        })

        naverLogin.init();// useEffect로 안하고 onclick하면 로그인배너아이콘 안뜸
    }, [metaInfo]);

    const handleClick = () => {
        naverRef.current.children[0].click();
    }

    return (
        <>
            <div ref={naverRef} id='naverIdLogin'>
            </div>
            <button className='login-btn' onClick={handleClick}>
                <img className="icon naver" alt={"네이버 로그인"} src="/assets/img/naver_logo.png" />
            </button>
        </>
    )
}

export default NaverLoginBtn;

